import { Text, UseDisclosureReturn, VStack } from "@chakra-ui/react";
import { getAccountShortName } from "@syla/shared/types/models/AccountAccessBase";
import { AccountAccessWithUserPopulated } from "@syla/shared/types/responses/GetAccountsResponse";
import React from "react";
import { ConfirmActionModal } from "../../../components/modals/ConfirmActionModal";
import { useMutationUpdateAccountAccess } from "../../../store/useMutationUpdateAccountAccess";
import { Account } from "../../../types/Account";

export function RemoveAccountAccessModal({
  account,
  accountId,
  accountAccess,
  ownAccess,
  disclosure,
}: {
  account: Account;
  accountId: string;
  accountAccess: AccountAccessWithUserPopulated;
  ownAccess: boolean;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const shortName = getAccountShortName(account);

  const mutationUpdateAccountAccess = useMutationUpdateAccountAccess(accountId);

  const removeAccess = async () => {
    await mutationUpdateAccountAccess.mutateAsync({
      ops: [
        {
          action: "delete",
          userId: accountAccess.user._id,
        },
      ],
    });
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title={ownAccess ? "Remove your access?" : "Remove this member?"}
      confirmButtonText={ownAccess ? "Remove my access" : "Remove member"}
      colorScheme="red"
      onConfirm={removeAccess}
    >
      <VStack align="stretch" spacing={6}>
        {ownAccess ?
          <>
            <Text>
              You’re about to remove your access to{" "}
              <Text as="span" fontWeight="bold">
                {shortName}
              </Text>
              .
            </Text>
            <Text>
              After this, you won’t be able to view or manage this account
              unless another account owner adds you again.
            </Text>
          </>
        : <>
            <Text>
              You’re about to remove{" "}
              <Text as="span" fontWeight="bold">
                {accountAccess.user.email}
              </Text>{" "}
              from{" "}
              <Text as="span" fontWeight="bold">
                {shortName}
              </Text>
              .
            </Text>
            <Text>
              They won’t be able to view or manage this account unless they’re
              added again.
            </Text>
          </>
        }
      </VStack>
    </ConfirmActionModal>
  );
}
